export default __webpack_public_path__ + "static/media/IMG9.79510d4b.jpg";